/* tslint:disable */
/* eslint-disable */
/**
 * Bikeleasing Accounts
 * Consumers of the API must follow the tolerant reader pattern. Especially the consumer    * must ignore unknown properties   * expect enumerations to be extended at any time (this includes discriminators)      These changes are considered backwards compatible.   However, we will never do a backwards-incompatible change without creating a new API version:   * removal of required properties   * removal of a supported request parameter   * adding a new required request parameter or attributes   * renaming of an attribute      All responses contain a common header `X-Request-Id` which identifies the individual HTTP request. This ID should be included in any bug reports or support requests.  There is a per-client rate limit on the API. If the rate limit is exceeded (resulting in a \"429 Too Many Requests\" response), please slow down and retry  after a short delay.  The API strives to return status codes that align with user expectations. However, in some error cases, multiple status codes may seem appropriate, and  the expected status code might not be clear. Here are two important points to consider when dealing with error status codes: 1. The API first checks the user\'s permission to access a resource. Only if the user has permission, it attempts to retrieve the resource. As a consequence, a user will     see a `403 Access Denied` status when requesting non-existent single resources since the permission check fails first. 2. There are no permissions on collections, only on the resources contained within them. Therefore, the API never returns a `403 Access Denied` status because the user     lacks permission to access a collection. Instead, the API returns a list containing all resources the user has permission to access. If the user has no permission to any     resource in the collection, an empty list with a `200 OK` status code is returned.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InlineObject } from '../dto';
// @ts-ignore
import type { InlineObject1 } from '../dto';
// @ts-ignore
import type { PublicCompanyResponse } from '../dto';
// @ts-ignore
import type { ValidateRegistrationCodeRequest } from '../dto';
// @ts-ignore
import type { ValidateRegistrationCodeResponse } from '../dto';
/**
 * PublicApi - axios parameter creator
 * @export
 */
export const PublicApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve limited public information about a company by its UUID. This endpoint is publicly accessible and does not require authentication. Returns only the company ID and name.
         * @summary Get public company information
         * @param {string} uuid The unique identifier of the company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicCompany: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getPublicCompany', 'uuid', uuid)
            const localVarPath = `/api/v1/public/companies/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validate a registration code without redeeming it, and retrieve information about the associated company. This endpoint is publicly accessible and does not require authentication. Call this before registration, so the user knows which company they are registering with.
         * @summary Validate a registration code
         * @param {ValidateRegistrationCodeRequest} validateRegistrationCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateRegistrationCode: async (validateRegistrationCodeRequest: ValidateRegistrationCodeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'validateRegistrationCodeRequest' is not null or undefined
            assertParamExists('validateRegistrationCode', 'validateRegistrationCodeRequest', validateRegistrationCodeRequest)
            const localVarPath = `/api/v1/public/registration-codes/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateRegistrationCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicApi - functional programming interface
 * @export
 */
export const PublicApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve limited public information about a company by its UUID. This endpoint is publicly accessible and does not require authentication. Returns only the company ID and name.
         * @summary Get public company information
         * @param {string} uuid The unique identifier of the company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicCompany(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicCompanyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicCompany(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.getPublicCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validate a registration code without redeeming it, and retrieve information about the associated company. This endpoint is publicly accessible and does not require authentication. Call this before registration, so the user knows which company they are registering with.
         * @summary Validate a registration code
         * @param {ValidateRegistrationCodeRequest} validateRegistrationCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateRegistrationCode(validateRegistrationCodeRequest: ValidateRegistrationCodeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateRegistrationCodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateRegistrationCode(validateRegistrationCodeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.validateRegistrationCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PublicApi - factory interface
 * @export
 */
export const PublicApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicApiFp(configuration)
    return {
        /**
         * Retrieve limited public information about a company by its UUID. This endpoint is publicly accessible and does not require authentication. Returns only the company ID and name.
         * @summary Get public company information
         * @param {PublicApiGetPublicCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicCompany(requestParameters: PublicApiGetPublicCompanyRequest, options?: RawAxiosRequestConfig): AxiosPromise<PublicCompanyResponse> {
            return localVarFp.getPublicCompany(requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Validate a registration code without redeeming it, and retrieve information about the associated company. This endpoint is publicly accessible and does not require authentication. Call this before registration, so the user knows which company they are registering with.
         * @summary Validate a registration code
         * @param {PublicApiValidateRegistrationCodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateRegistrationCode(requestParameters: PublicApiValidateRegistrationCodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ValidateRegistrationCodeResponse> {
            return localVarFp.validateRegistrationCode(requestParameters.validateRegistrationCodeRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getPublicCompany operation in PublicApi.
 * @export
 * @interface PublicApiGetPublicCompanyRequest
 */
export interface PublicApiGetPublicCompanyRequest {
    /**
     * The unique identifier of the company
     * @type {string}
     * @memberof PublicApiGetPublicCompany
     */
    readonly uuid: string
}

/**
 * Request parameters for validateRegistrationCode operation in PublicApi.
 * @export
 * @interface PublicApiValidateRegistrationCodeRequest
 */
export interface PublicApiValidateRegistrationCodeRequest {
    /**
     * 
     * @type {ValidateRegistrationCodeRequest}
     * @memberof PublicApiValidateRegistrationCode
     */
    readonly validateRegistrationCodeRequest: ValidateRegistrationCodeRequest
}

/**
 * PublicApi - object-oriented interface
 * @export
 * @class PublicApi
 * @extends {BaseAPI}
 */
export class PublicApi extends BaseAPI {
    /**
     * Retrieve limited public information about a company by its UUID. This endpoint is publicly accessible and does not require authentication. Returns only the company ID and name.
     * @summary Get public company information
     * @param {PublicApiGetPublicCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApi
     */
    public getPublicCompany(requestParameters: PublicApiGetPublicCompanyRequest, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).getPublicCompany(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validate a registration code without redeeming it, and retrieve information about the associated company. This endpoint is publicly accessible and does not require authentication. Call this before registration, so the user knows which company they are registering with.
     * @summary Validate a registration code
     * @param {PublicApiValidateRegistrationCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApi
     */
    public validateRegistrationCode(requestParameters: PublicApiValidateRegistrationCodeRequest, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).validateRegistrationCode(requestParameters.validateRegistrationCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

